module.exports = __webpack_public_path__ + "img/39_15.28603914.png";